import { v4 as uuidv4 } from 'uuid';

export function ProductPrice() {
	return {
		componentName: 'ProductPrice',
		componentId: uuidv4(),
		props: {
			savings: {
				percentageStyle: 'locale',
			},
		},
		childrenComponents: [],
	};
}
